import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FinalCTA = () => {
  const { t } = useTranslation();

  return (
    <section
      id="cta"
      style={{
        background: 'linear-gradient(180deg, var(--bf-bg-alt) 0%, var(--bf-bg) 100%)',
        color: 'var(--bf-ink)',
        padding: '150px 0',
        position: 'relative',
        overflow: 'hidden',
        borderTop: '1px solid var(--bf-rule)',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: -260,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 900,
          height: 620,
          background: 'radial-gradient(50% 50% at 50% 50%, rgba(240,31,61,0.28) 0%, rgba(240,31,61,0.06) 40%, transparent 72%)',
          pointerEvents: 'none',
        }}
      />
      <div className="bf-container" style={{ position: 'relative' }}>
        <div
          className="bf-cta-grid"
          style={{ display: 'grid', gridTemplateColumns: '1.3fr 1fr', gap: 80, alignItems: 'end' }}
        >
          <div>
            <span className="bf-eyebrow" style={{ color: 'var(--bf-muted-2)' }}>
              <span className="dot"></span>
              {t('cta.eyebrow', 'See it in your EMR')}
            </span>
            <h2 style={{ color: 'var(--bf-ink)', marginTop: 28 }}>
              {t('cta.titleA', 'Turn your EMR into')}
              <br />
              <span className="bf-serif-italic" style={{ color: '#a8a29e' }}>
                {t('cta.titleB', 'a clinical reasoning system.')}
              </span>
            </h2>
          </div>
          <div>
            <p style={{ color: '#d6d3d1', fontSize: 17, maxWidth: '42ch', lineHeight: 1.55 }}>
              {t(
                'cta.body',
                'See it live, with a clinical lead from our team.'
              )}
            </p>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 32 }}>
              <a
                href="https://calendly.com/tiago-costa-bloodflow"
                target="_blank"
                rel="noopener noreferrer"
                className="bf-btn bf-btn-light bf-btn-lg"
              >
                {t('cta.start', 'Schedule a demo')} <span className="bf-arrow">→</span>
              </a>
              <Link to="/contact-sales" className="bf-btn bf-btn-ghost-dark bf-btn-lg">
                {t('cta.talk', 'Contact our team')}
              </Link>
            </div>
            <div
              className="bf-small"
              style={{ marginTop: 20, color: 'var(--bf-muted-2)', textTransform: 'none', letterSpacing: '0.02em' }}
            >
              {t('cta.contact', 'support@bloodflow.ai')}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .bf-cta-grid { grid-template-columns: 1fr !important; gap: 40px !important; align-items: start !important; }
        }
      `}</style>
    </section>
  );
};

export default FinalCTA;
